module.exports = __webpack_public_path__ + "static/media/Plus.c0ca621f.svg";